export const T = {
  en_GB: { loading: "Loading editor..." },
  nb_NO: { loading: "Laster redigeringsverktøy..." },
} as const;
